import React, {
  useMemo, forwardRef, memo, useState,
  useCallback, useEffect,
} from 'react';
import { NavLink as RouterLink, useLocation } from 'react-router-dom';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';

import {
  DrawerListItem,
  DrawerListItemText,
  DrawerListItemIcon,
} from './styled';
import LinkList from './LinkList';

function ListItemLink({ iconComponent, primary, to, children }) {
  const renderLink = useMemo(
    () => forwardRef((itemProps, ref) => <RouterLink to={to} ref={ref} {...itemProps} activeClassName="active" />),
    [to],
  );
  const { pathname } = useLocation();
  const IconComponent = iconComponent;
  const [open, setOpen] = useState(to === '#' || to.startsWith(pathname));
  const handleClick = useCallback(() => setOpen(!open), [open]);
  useEffect(() => {
    setOpen(to === '#' || to.startsWith(pathname));
  }, [to, pathname]);

  return (primary==='Impact Receipt'
    ? <li style={{ height: 0 }}></li>
    : <div>
        <DrawerListItem button component={renderLink} onClick={handleClick}>
          {IconComponent && <DrawerListItemIcon><IconComponent/></DrawerListItemIcon>}
          <DrawerListItemText primary={primary} />
          {children && (open ? <ExpandLess /> : <ExpandMore />)}
        </DrawerListItem>
        {children && <LinkList nested links={children} {...{ open }}/>}
      </div>
  );
}

export default memo(ListItemLink);